import {getAppConfigVar} from '../config';


/**
 *
 */
const addWCAGEnhancements = () =>
{
	addScreenReaderPrevNextLinks();
	addScreenReaderSkipLink();
};


/**
 * Adds a "Skip to content" link for screen readers
 *
 * @see https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks
 */
const addScreenReaderSkipLink = () =>
{
	const main = document.querySelector( 'main' );

	if (main instanceof HTMLElement) {

		if (!main.id.length) {
			main.id = 'screen-reader-skip-link-target';
		}

		const skipLink = document.createElement( 'a' );

		skipLink.classList.add( 'skip-link', 'keyboard-focus-link', 'visually-hidden-focusable' );
		skipLink.href      = `#${main.id}`;
		skipLink.innerText = `Skip to content`;

		document.body.insertAdjacentElement( 'afterbegin', skipLink );
	}
};


/**
 * Adds previous/next navigation for screen readers to allow another way to navigate the site
 *
 * @see https://www.w3.org/WAI/WCAG21/Understanding/multiple-ways.html
 */
const addScreenReaderPrevNextLinks = () =>
{
	const sitemapUrls = getAppConfigVar( 'sitemapUrls' );

	if (!Array.isArray( sitemapUrls )) {
		return;
	}

	const baseUrl     = `${window.location.protocol}//${window.location.host}`;
	const urlRegex    = new RegExp( `^${window.location.pathname}` );
	const thisLinkKey = sitemapUrls.findIndex( url => url.match( urlRegex ) );

	if (thisLinkKey !== -1) {

		const prevLinkKey = thisLinkKey === 0 ? sitemapUrls.length - 1 : thisLinkKey - 1;
		const nextLinkKey = thisLinkKey === sitemapUrls.length - 1 ? 0 : thisLinkKey + 1;
		const prevLink    = baseUrl + sitemapUrls[prevLinkKey];
		const nextLink    = baseUrl + sitemapUrls[nextLinkKey];
		const navHtml     = `
			<nav role="navigation" aria-label="Site previous/next navigation" class="sitemap-prev-next-nav">
				<ul>
					<li>
						<a href="${nextLink}" class="keyboard-focus-link visually-hidden-focusable">
							Go forward 1 page (${nextLinkKey + 1} of ${sitemapUrls.length})
						</a>
					</li>
					<li>
						<a href="${prevLink}" class="keyboard-focus-link visually-hidden-focusable">
							Go backward 1 page (${prevLinkKey + 1} of ${sitemapUrls.length})
						</a>
					</li>
				</ul>
			</nav>
		`;

		document.body.insertAdjacentHTML( 'afterbegin', navHtml );
	}
};


/**
 *
 */
export default addWCAGEnhancements;